import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PerfilComponent } from './components/perfil/perfil.component';

//new
import { AdministrarblogComponent } from './components/administrarblog/administrarblog.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { AdministraCategoriasComponent } from './components/administra-categorias/administra-categorias.component';
import { AdministraProductosComponent } from './components/administra-productos/administra-productos.component';
import { AdministraMarcasComponent } from './components/administra-marcas/administra-marcas.component';
import { ReporteVentasComponent } from './components/reporte-ventas/reporte-ventas.component';
import { AdministraImgProductoComponent } from './components/administra-img-producto/administra-img-producto.component';
import { AdministraImgMcComponent } from './components/administra-img-mc/administra-img-mc.component';




const APP_ROUTES: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'perfil', component: PerfilComponent },
  { path: 'uploadFile', component: UploadFileComponent },
  { path: 'administraMarcas', component: AdministraMarcasComponent },
  { path: 'reporteVentas', component: ReporteVentasComponent },
  { path: 'administraCategorias/:idMarca', component: AdministraCategoriasComponent },
  { path: 'administraProductos/:idCategoria', component: AdministraProductosComponent },
  { path: 'administraImgProducto/:idProducto/:nombre/:idCategoria', component: AdministraImgProductoComponent },
  { path: 'administraImgMc/:nombre/:idCategoria', component: AdministraImgMcComponent },
  { path: 'administrarBlog', component: AdministrarblogComponent },
  { path: '**', pathMatch: 'full', redirectTo: '/perfil' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true });



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/app.routes.ts